import * as _ from "lodash";
import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { CheckManager } from "../../shared/check-manager";
import { FilterDataProvider } from "../../data-provider/filter.dp";
import { NavigationBarHelperService } from "../navigation/navigation-bar.helper";
import { PermissionCheck } from "../../shared/permission";
import { InviteService } from "../../services/invite.service";
import { TeamDataProvider } from "../../data-provider/team.dp";
import { DialogUtils } from "../../helper/dialog.helper";
import { ToastUtils } from "../../helper/toast.helper";
import { UserDataProvider } from "../../data-provider/user.dp";
import { User } from "../../models/user.model";
import { Team } from "../../models/team.model";
import { SearchUtils } from "../../helper/search.helper";

let UserListComponent = {
    templateUrl: "/angular/components/user/user-list.component.html",
    selector: "vcUserList",
    bindings: {
        myModel: "<",
    },
    controller: class UserListController {
        // * bindings for typescript compiler *
        public myModel: any;
        // ************************************

        private $scope: any;
        private searchUtils: SearchUtils;
        private $q: any;
        private $location: any;
        private $interval: any;
        private teamDataProvider: TeamDataProvider;
        private filterDataProvider: FilterDataProvider;
        private inviteService: InviteService;
        private dialog: DialogUtils;
        private toast: ToastUtils;
        private __env: any;
        private search: any;

        public dataProvider: UserDataProvider;
        public campaignDataProvider: CampaignDataProvider;
        public checkManager: CheckManager;
        public navigationBarService: NavigationBarHelperService;
        public permissionProvider: PermissionCheck;
        public signedInUser: any;
        public filter: any;
        public users: any;
        public filteredUsers: any;
        public activeCampaign: any;
        public searchDelay?: any;
        public previousFilter?: any;
        public invites?: any;

        constructor(
            $scope: any,
            $q: any,
            $location: any,
            $interval: any,
            __env: any,
            UserDataProvider: UserDataProvider,
            SearchUtils: SearchUtils,
            CampaignDataProvider: CampaignDataProvider,
            TeamDataProvider: TeamDataProvider,
            NavigationBarHelperService: NavigationBarHelperService,
            FilterDataProvider: FilterDataProvider,
            InviteService: InviteService,
            DialogUtils: DialogUtils,
            ToastUtils: ToastUtils,
            PermissionCheck: PermissionCheck
        ) {
            this.$scope = $scope;
            this.dataProvider = UserDataProvider;
            this.searchUtils = SearchUtils;
            this.$q = $q;
            this.campaignDataProvider = CampaignDataProvider;
            this.$location = $location;
            this.$interval = $interval;
            this.checkManager = this.dataProvider.checkManager;
            this.teamDataProvider = TeamDataProvider;
            this.navigationBarService = NavigationBarHelperService;
            this.filterDataProvider = FilterDataProvider;
            this.inviteService = InviteService;
            this.dialog = DialogUtils;
            this.toast = ToastUtils;
            this.permissionProvider = PermissionCheck;
            this.__env = __env;

            this.filterDataProvider.setPage("users");
            this.filter = this.filterDataProvider.appliedFilter;
            this.search = "";
            this.activeCampaign = this.campaignDataProvider.activeCampaign;
            this.signedInUser = this.dataProvider.getActiveUser();

            if (this.filter.search && this.filter.search.values) {
                this.searchUtils.searchText = _.cloneDeep(
                    this.filter.search.values
                );
                this.search = this.searchUtils.searchText;
            }

            this.searchUtils.setSearchBar(
                "Search Users",
                (searchText) => {
                    this.search = searchText;
                    return this.$q.resolve([]);
                },
                null,
                true
            );

            this.campaignDataProvider.getCustomFieldColumns();

            this.$scope.$watch(
                () => this.search,
                (newValue: string, oldValue: string) => {
                    if (oldValue != newValue) {
                        this.dataProvider.loading = true;
                        if (this.searchDelay) {
                            this.searchDelay = this.$interval.cancel(
                                this.searchDelay
                            );
                        }
                        this.searchDelay = this.$interval(() => {
                            this.$interval.cancel(this.searchDelay);
                            this.filterDataProvider.filter.search.values =
                                this.search;
                            this.filter.search.values = _.cloneDeep(
                                this.search
                            );
                            this.dataProvider.setFilter(this.filter);
                        }, 2000);
                    }
                },
                true
            );

            this.$scope.$watch(
                () => this.filter,
                (newValue: any, oldValue: any) => {
                    if (
                        !this.previousFilter ||
                        (newValue &&
                            !angular.equals(
                                newValue.nonEmptyValues(),
                                oldValue.nonEmptyValues()
                            )) ||
                        (Object.keys(newValue).length &&
                            !Object.keys(oldValue).length)
                    ) {
                        if (
                            !this.previousFilter &&
                            Object.keys(this.filter.nonEmptyValues()).length > 0
                        ) {
                            this.navigationBarService.setFilterBarOpen(true);
                        }
                        this.previousFilter = _.cloneDeep(newValue);
                        this.dataProvider.setFilter(this.filter);
                    }
                },
                true
            );
        }

        goToUser(user: User): void {
            this.dataProvider.checkManager.checked_items = [];
            this.$location.url("/user/" + user.uid);
        }

        dateTime(): number {
            return new Date().getTime();
        }

        isLeaderUser(user: User): boolean {
            return (
                user.permissionid == 8 ||
                user.permissionid == 9 ||
                user.permissionid == 10
            );
        }

        openUserModal(user: User, event: any): void {
            this.dialog
                .show({
                    component: "vc-update-user-dialog",
                    targetEvent: event,
                    clickOutsideToClose: false,
                    scope: this.$scope,
                    size: "large",
                    locals: {
                        user: user,
                    },
                })
                .then((data: any) => {
                    user.setData(data);
                });
        }

        deleteUserModal(user: User, ev: any): void {
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        title: `Delete User?`,
                        bodyText: "They will be permanently deleted",
                    },
                })
                .then(() => {
                    this.dataProvider.removeUser(user).then(
                        () => {
                            this.toast.success("User Deleted");
                            this.teamDataProvider.clearAll();
                            this.dataProvider.resetItems();
                        },
                        () => this.toast.error()
                    );
                });
        }

        resetPassword(user): void {
            this.dataProvider.resetPassword(user.uemail).then(
                () => {
                    this.toast.success(
                        "A reset password email has been sent to " + user.uemail
                    );
                },
                () => {
                    this.toast.error();
                }
            );
        }

        scrollLoad(lastHouse: any): void {
            if (!this.dataProvider.scrollLoading) {
                this.dataProvider.getFilteredUsers(lastHouse, true);
            }
        }

        bulk_delete(ev: any): void {
            const count = this.dataProvider.checkManager.checked_items_count;
            this.dialog
                .delete({
                    fullscreen: true,
                    targetEvent: ev,
                    skipHide: true,
                    locals: {
                        title: `Delete ${count} ${
                            count > 1 ? "Users" : "User"
                        }?`,
                        bodyText: `They will be permanently deleted`,
                    },
                })
                .then(() => {
                    this.dataProvider
                        .bulkDelete(
                            this.dataProvider.checkManager.checked_items
                        )
                        .then(
                            () => this.toast.success("Users deleted"),
                            (json) => this.toast.error(json.message)
                        );
                });
        }

        bulk_add_to_team(ev: any): void {
            this.dialog
                .show({
                    component: "vc-add-to-team",
                    targetEvent: ev,
                    scope: this.$scope,
                    ariaLabel: "Create Point",
                    locals: {},
                })
                .then((team: Team) => {
                    if (team) {
                        this.teamDataProvider
                            .addToTeam(
                                this.dataProvider.checkManager.checked_items,
                                team
                            )
                            .then(
                                () => {
                                    angular.forEach(
                                        this.dataProvider.filteredUsers,
                                        (user) => {
                                            if (
                                                this.checkManager.checked_items.indexOf(
                                                    user.uid
                                                ) > -1
                                            ) {
                                                let tids = user.teams.map(
                                                    (item: any) => {
                                                        return item["tid"];
                                                    }
                                                );
                                                if (!tids.includes(team.tid)) {
                                                    user.teams.push(team);
                                                }
                                            }
                                        }
                                    );

                                    this.toast.success(
                                        this.checkManager.checked_items_count +
                                            " users added to " +
                                            team.tname
                                    );
                                    this.checkManager.checkAll(false);
                                },
                                () => this.toast.error()
                            );
                    }
                });
        }

        activate(user: User, ev: any): void {
            this.dataProvider.confirmActivateDialog([user], [], ev);
        }

        deactivate(user: User, ev: any): void {
            this.dataProvider.activateUsers([user.uid], [], 0);
        }

        bulk_activate(ev: any): void {
            const users = this.dataProvider.filteredUsers.filter(
                (item: any) => {
                    return item.locked == "0" && item.checked;
                }
            );

            this.dataProvider.confirmActivateDialog(users, [], ev).then(() => {
                this.checkManager.checkAll(false);
            });
        }

        bulk_deactivate(ev): void {
            const users = this.dataProvider.filteredUsers.filter(
                (user: any) => user.seated == "1" && user.checked
            );
            this.dataProvider.deactivateUsers(users, [], ev);
        }

        matchSearch(user, search): boolean {
            let lcSearch = search.toLowerCase();

            return (
                (user.ufname && user.ufname.toLowerCase().includes(lcSearch)) ||
                (user.ulname && user.ulname.toLowerCase().includes(lcSearch)) ||
                (user.ufname &&
                    user.ulname &&
                    (user.ufname + " " + user.ulname)
                        .toLowerCase()
                        .includes(lcSearch)) ||
                (user.uemail && user.uemail.toLowerCase().includes(lcSearch)) ||
                (user.uphonenumber &&
                    user.ucountrycode &&
                    (user.ucountrycode + user.uphonenumber).includes(
                        lcSearch
                    )) ||
                (user.permissionid &&
                    this.permissionProvider
                        .getPermission(user.permissionid)
                        ?.permissionname.toLowerCase()
                        .includes(lcSearch)) ||
                (user.campaigninvitephonenumber &&
                    user.campaigninvitecountrycode &&
                    (
                        user.campaigninvitecountrycode +
                        user.campaigninvitephonenumber
                    ).includes(lcSearch)) ||
                (user.campaigninviteemail &&
                    user.campaigninviteemail.toLowerCase().includes(lcSearch))
            );
        }
    },
};

angular.module("user").component(UserListComponent.selector, UserListComponent);
